module.exports = __webpack_public_path__ + "static/img/hbBtn2.070feb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/hbBtn2.png
// module id = yG/1
// module chunks = 0